"use client";
/**
 * Toast Hook - Now using Sonner for consistent toast notifications
 * 
 * This is a bridge that redirects the old useToast API to sonner.
 * All components using useToast({ title, description, variant }) will now
 * display toasts using sonner.
 */
import { toast as sonnerToast } from 'sonner';

/**
 * Bridge function that converts old toast API to sonner
 */
function toast({ title, description, variant, ...rest }) {
  // Map variant to sonner toast type
  if (variant === 'destructive') {
    return sonnerToast.error(title, { description, ...rest });
  } else if (variant === 'success') {
    return sonnerToast.success(title, { description, ...rest });
  } else if (variant === 'warning') {
    return sonnerToast.warning(title, { description, ...rest });
  } else {
    // Default toast
    return sonnerToast(title, { description, ...rest });
  }
}

/**
 * useToast hook - Returns toast function for component use
 * Maintains backwards compatibility with existing code
 */
function useToast() {
  return {
    toast,
    toasts: [], // sonner manages its own state
    dismiss: (toastId) => sonnerToast.dismiss(toastId),
  };
}

export { useToast, toast };
